angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/components/topbar/topbar.html',
    '<!-- Header class="navbar minified navbar-fixed-top" -->\n' +
    '<header ng-class="{\'navbar navbar-fixed-top\': animateHeader2()&&!white2, \'navbar minified navbar-fixed-top\': !animateHeader2()||white2,\'bg-white tog-menu\': white }"\n' +
    '    ng-controller="TopbarController" ng-show="visibleHeaderFooter()">\n' +
    '    <div class="container-fluid">\n' +
    '        <div ng-click="imagePressWhite()" class="user-dashboard" data-toggle="collapse" data-target="#user-utility" ng-if="!isNotLoggedIn()">\n' +
    '            <ul class="list-inline">\n' +
    '                <li class="user-name hidden-xs">{{user.FirstName}}</li>\n' +
    '                <li class="user-photo" style="background-image:url({{user.Picture.Url}}),url(assets/img/avatar.png);"></li>\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '        <div class="navbar-header dashboard">\n' +
    '            <a class="navbar-toggle dashboard" data-toggle="collapse" data-target=".navbar-collapse" ng-click="hamburger()"></a>\n' +
    '            <a href="" ui-sref="index" class="logo">\n' +
    '                <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                    <polygon class="pol-a" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53" />\n' +
    '                    <polygon class="pol-b" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7" />\n' +
    '                    <polygon class="pol-c" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3" />\n' +
    '                </svg>\n' +
    '                <!-- This logo needs to be kept in two lines to avoid spaces between "PE" and "4H-->\n' +
    '                <div><strong>pe</strong>\n' +
    '                    <span>4</span>h</div>\n' +
    '            </a>\n' +
    '        </div>\n' +
    '        <nav id="my-nav" class="navbar-collapse dashboard collapse" ng-if="!isNotLoggedIn()">\n' +
    '            <ul class="nav navbar-nav" ng-if="isUser()">\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="proposals" ng-click="hideNavBar()">My Projects</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="requests" ng-click="hideNavBar()">Open Projects</a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '            <ul class="nav navbar-nav" ng-if="isClient()">\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="projects" ng-click="hideNavBar()">My projects</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="post-project" ng-click="hideNavBar()">new project</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="view-engineers({description:\'engineers\'})" ng-click="hideNavBar()">\n' +
    '                        <span class="hidden-sm"></span>engineers</a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </nav>\n' +
    '        <nav id="my-nav" class="navbar-collapse collapse" ng-if="isNotLoggedIn()">\n' +
    '            <ul class="nav navbar-nav">\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="post-project" ng-click="hideNavBar()">get started</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="view-engineers({description:\'engineers\'})" ng-click="hideNavBar()">\n' +
    '                        <span class="hidden-sm">view</span> engineers</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="view-projects" ng-click="hideNavBar()">\n' +
    '                        <span class="hidden-sm">view</span> projects</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ui-sref="first-step" ng-click="hideNavBar()">sign up</a>\n' +
    '                </li>\n' +
    '                <li ui-sref-active="active">\n' +
    '                    <a href="" ng-click="loginTopBar()" class="btn btn-primary" ng-click="hideNavBar()">log in</a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </nav>\n' +
    '        <div id="user-utility" class="collapse pull-right">\n' +
    '            <ul class="user-utility">\n' +
    '                <li class="active">\n' +
    '                    <a href="" ui-sref="profile" data-toggle="collapse" data-target="#user-utility" ng-click="hideNavBar()">Profile\n' +
    '                        <i class="fa fa-user fa-fw"></i>\n' +
    '                    </a>\n' +
    '                </li>\n' +
    '                <li>\n' +
    '                    <a href="" data-toggle="collapse" data-target="#user-utility" ng-click="logOut()" class="signout" ng-click="hideNavBar()">Sign\n' +
    '                        Out\n' +
    '                        <i class="fa fa-sign-out fa-fw alt"></i>\n' +
    '                    </a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</header>');
}]);
